<template>
	<!-- TODO: WHOOHOOOOO INLINESTYLE FOR THE WORLD -->
	<Modal
		ref="modal"
		overlay-type="login"
		full-screen
		@data="setData"
	>
		<div class="overlay-login">
			<div class="overlay-login__wrapper">
				<div class="overlay-login__info" v-html="$t('login.infoHtml')" />

				<div class="overlay-login__forms">
					<div class="overlay-login__tabs">
						<button
							class="overlay-login__tab"
							:class="{
								'overlay-login__tab--active': activeTab == 'login'
							}"
							v-html="$t('login.loginTab')"
							type="button"
							@click.prevent="setActiveTab('login')"
						/>
						<button
							class="overlay-login__tab"
							:class="{
								'overlay-login__tab--active': activeTab == 'register'
							}"
							v-html="$t('login.registerTab')"
							type="button"
							@click.prevent="setActiveTab('register')"
						/>
					</div>

					<div
						class="overlay-login__tab-content"
						v-show="activeTab == 'login'"
					>
						<FormLogin
							hide-title
							ref="loginForm"
							@loggedIn="onLoggedIn"
						/>

						<h3 v-html="$t('login.loginRegisterTitle')"/>
						<Button
							@click.prevent="setActiveTab('register')"
							type="button"
							level="tertiary"
							:text="$t('login.loginRegisterButton')"
							arrow
						/>
					</div>

					<div
						class="overlay-login__tab-content"
						v-show="activeTab == 'register'"
					>
						<FormRegister
							hide-title
							ref="registerForm"
						/>
						<h3 v-html="$t('login.registerLoginTitle')"/>
						<Button
							@click.prevent="setActiveTab('login')"
							type="button"
							level="tertiary"
							:text="$t('login.registerLoginButton')"
							arrow
						/>
					</div>
				</div>
			</div>
			<div class="overlay-login__pattern"/>
		</div>
	</Modal>

</template>

<script>
import Vue from "vue"
import {mapGetters} from 'vuex'
import GenericMixin from '@/mixins/GenericVueMixin';
import OverlayMixin from '@/mixins/OverlayVueMixin';
import FormLogin from '@/components/FormLogin';
import FormRegister from '@/components/FormRegister';
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import htmlComponent from 'htmlcomponent'
import sleep from '@/utils/sleep';

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		FormLogin,
		FormRegister,
		Modal,
		Button,
	},
	props: {
	},
	data() {
		return {
			modalData: {},
			activeTab: 'login',
		}
	},
	computed: {

	},
	watch: {
		modalData(data) {
			this.setActiveTab(data.tab);
		}
	},
	methods: {
		setData(newData) {
			Vue.set(this, 'modalData', newData);
		},
		setActiveTab(tab = 'login') {
			this.activeTab = tab;
		},
		resetForm() {
			this.$refs.loginForm.resetForm();
			this.$refs.registerForm.resetForm();
		},
		async onLoggedIn() {
			await sleep(2000);
			this.$refs.modal.close();
		},
	},
}
</script>

<style>

</style>
